import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export const Safeguard = () => {
  const svgRef = useRef(null);
  const svgInView = useInView(svgRef, { once: true });

  return (
    <svg
      ref={svgRef}
      width="1066"
      height="278"
      viewBox="0 0 1066 278"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        overflow: 'visible',
        transform: 'translate(407px, 245px)',
      }}
    >
      <motion.ellipse
        opacity="0.25"
        cx="25"
        cy="79"
        rx="25"
        ry="25"
        fill="var(--brand-color-red-5)"
        initial={{ opacity: 0, x: -326 }}
        animate={
          svgInView && {
            opacity: 0.25,
            x: 0,
            transition: { duration: 1, ease: 'easeOut' },
          }
        }
      />
      <motion.path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.9613 80.4025L64.4636 80.3197C64.4878 79.883 64.5 79.443 64.5 79C64.5 78.557 64.4878 78.117 64.4636 77.6803L65.9613 77.5975C65.987 78.0617 66 78.5293 66 79C66 79.4707 65.987 79.9383 65.9613 80.4025ZM65.6505 74.8103L64.1714 75.0599C64.0239 74.1861 63.8283 73.3289 63.5873 72.4909L65.0289 72.0763C65.2854 72.9682 65.4936 73.8805 65.6505 74.8103ZM64.103 69.4303C63.7433 68.5628 63.3361 67.72 62.8847 66.905L61.5725 67.6318C61.9968 68.3977 62.3794 69.1898 62.7174 70.0049L64.103 69.4303ZM61.3908 64.5322L60.1682 65.4013C59.6581 64.6837 59.1088 63.996 58.5232 63.3412L59.6413 62.3413C60.264 63.0376 60.8483 63.769 61.3908 64.5322ZM57.6587 60.3587L56.6588 61.4768C56.004 60.8912 55.3163 60.3419 54.5987 59.8318L55.4678 58.6092C56.231 59.1517 56.9624 59.736 57.6587 60.3587ZM53.095 57.1153L52.3682 58.4275C51.6023 58.0032 50.8102 57.6206 49.9951 57.2826L50.5697 55.897C51.4372 56.2567 52.28 56.6639 53.095 57.1153ZM47.9237 54.9712L47.5091 56.4127C46.6712 56.1717 45.8139 55.9761 44.9401 55.8286L45.1897 54.3495C46.1195 54.5064 47.0318 54.7146 47.9237 54.9712ZM42.4025 54.0387L42.3197 55.5364C41.883 55.5122 41.443 55.5 41 55.5C40.557 55.5 40.117 55.5122 39.6803 55.5364L39.5975 54.0387C40.0617 54.013 40.5293 54 41 54C41.4707 54 41.9383 54.013 42.4025 54.0387ZM36.8103 54.3495L37.0599 55.8286C36.1861 55.9761 35.3288 56.1717 34.4909 56.4127L34.0763 54.9712C34.9682 54.7146 35.8805 54.5064 36.8103 54.3495ZM31.4303 55.897L32.0049 57.2826C31.1898 57.6206 30.3977 58.0032 29.6318 58.4275L28.905 57.1153C29.72 56.6639 30.5628 56.2567 31.4303 55.897ZM26.5322 58.6092L27.4013 59.8318C26.6837 60.3419 25.996 60.8912 25.3412 61.4768L24.3413 60.3587C25.0376 59.736 25.769 59.1517 26.5322 58.6092ZM22.3587 62.3413L23.4768 63.3412C22.8912 63.996 22.3419 64.6837 21.8318 65.4013L20.6092 64.5322C21.1517 63.769 21.736 63.0376 22.3587 62.3413ZM19.1153 66.905L20.4275 67.6318C20.0032 68.3977 19.6206 69.1898 19.2826 70.0049L17.897 69.4303C18.2567 68.5628 18.6639 67.72 19.1153 66.905ZM16.9711 72.0763L18.4127 72.4909C18.1717 73.3288 17.9761 74.1861 17.8286 75.0599L16.3495 74.8103C16.5064 73.8805 16.7146 72.9682 16.9711 72.0763ZM16.0387 77.5975C16.013 78.0617 16 78.5293 16 79C16 79.4707 16.013 79.9383 16.0387 80.4025L17.5364 80.3197C17.5122 79.883 17.5 79.443 17.5 79C17.5 78.557 17.5122 78.117 17.5364 77.6803L16.0387 77.5975ZM16.3495 83.1897L17.8286 82.9401C17.9761 83.8139 18.1717 84.6712 18.4127 85.5091L16.9711 85.9237C16.7146 85.0318 16.5064 84.1195 16.3495 83.1897ZM17.897 88.5697L19.2826 87.9951C19.6206 88.8102 20.0032 89.6023 20.4275 90.3682L19.1153 91.095C18.6639 90.28 18.2567 89.4372 17.897 88.5697ZM20.6092 93.4678L21.8318 92.5987C22.3419 93.3163 22.8912 94.004 23.4768 94.6588L22.3587 95.6587C21.736 94.9624 21.1517 94.231 20.6092 93.4678ZM24.3413 97.6413C25.0376 98.264 25.769 98.8483 26.5322 99.3908L27.4013 98.1682C26.6837 97.6581 25.996 97.1088 25.3412 96.5232L24.3413 97.6413ZM28.905 100.885L29.6318 99.5725C30.3977 99.9968 31.1898 100.379 32.0049 100.717L31.4303 102.103C30.5628 101.743 29.72 101.336 28.905 100.885ZM34.0763 103.029L34.4909 101.587C35.3288 101.828 36.1861 102.024 37.0599 102.171L36.8103 103.65C35.8805 103.494 34.9682 103.285 34.0763 103.029ZM39.5975 103.961L39.6803 102.464C40.117 102.488 40.557 102.5 41 102.5C41.443 102.5 41.883 102.488 42.3197 102.464L42.4025 103.961C41.9383 103.987 41.4707 104 41 104C40.5293 104 40.0617 103.987 39.5975 103.961ZM45.1897 103.65L44.9401 102.171C45.8139 102.024 46.6712 101.828 47.5091 101.587L47.9237 103.029C47.0318 103.285 46.1195 103.494 45.1897 103.65ZM50.5697 102.103L49.9951 100.717C50.8102 100.379 51.6023 99.9968 52.3682 99.5725L53.095 100.885C52.28 101.336 51.4372 101.743 50.5697 102.103ZM55.4678 99.3908L54.5987 98.1682C55.3163 97.6581 56.004 97.1088 56.6588 96.5232L57.6587 97.6413C56.9624 98.264 56.231 98.8483 55.4678 99.3908ZM59.6413 95.6587L58.5232 94.6588C59.1088 94.004 59.6581 93.3163 60.1682 92.5987L61.3908 93.4678C60.8483 94.231 60.264 94.9624 59.6413 95.6587ZM62.8847 91.095L61.5725 90.3682C61.9968 89.6023 62.3794 88.8102 62.7174 87.9951L64.103 88.5697C63.7433 89.4372 63.3361 90.28 62.8847 91.095ZM65.0289 85.9237L63.5873 85.5091C63.8283 84.6712 64.0239 83.8139 64.1714 82.9401L65.6505 83.1897C65.4936 84.1195 65.2854 85.0318 65.0289 85.9237Z"
        fill="var(--brand-color-red-5)"
        initial={{ opacity: 0, x: -342 }}
        animate={
          svgInView && {
            opacity: 1,
            x: 0,
            transition: { duration: 1, ease: 'easeOut' },
          }
        }
      />
      <motion.path
        d="M81.25 79C81.25 92.3929 70.3929 103.25 57 103.25C43.6071 103.25 32.75 92.3929 32.75 79C32.75 65.6071 43.6071 54.75 57 54.75C70.3929 54.75 81.25 65.6071 81.25 79Z"
        stroke="var(--brand-color-red-5)"
        strokeWidth="1.5"
        initial={{ opacity: 0, x: -358 }}
        animate={
          svgInView && {
            opacity: 1,
            x: 0,
            transition: { duration: 1, ease: 'easeOut' },
          }
        }
      />
      <motion.ellipse
        cx="73"
        cy="79"
        rx="25"
        ry="25"
        fill="var(--brand-color-red-5)"
        initial={{ opacity: 0, x: -374 }}
        animate={
          svgInView && {
            opacity: 1,
            x: 0,
            transition: { duration: 1, ease: 'easeOut' },
          }
        }
      />
      <motion.ellipse
        opacity="0.25"
        cx="1081"
        cy="198"
        rx="25"
        ry="25"
        fill="var(--brand-color-red-5)"
        initial={{ opacity: 0, x: 326 }}
        animate={
          svgInView && {
            opacity: 0.25,
            x: 0,
            transition: { duration: 1, ease: 'easeOut' },
          }
        }
      />
      <motion.path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1040.04 196.597L1041.54 196.68C1041.51 197.117 1041.5 197.557 1041.5 198C1041.5 198.443 1041.51 198.883 1041.54 199.32L1040.04 199.403C1040.01 198.938 1040 198.471 1040 198C1040 197.529 1040.01 197.062 1040.04 196.597ZM1040.35 202.19L1041.83 201.94C1041.98 202.814 1042.17 203.671 1042.41 204.509L1040.97 204.924C1040.71 204.032 1040.51 203.119 1040.35 202.19ZM1041.9 207.57C1042.26 208.437 1042.66 209.28 1043.12 210.095L1044.43 209.368C1044 208.602 1043.62 207.81 1043.28 206.995L1041.9 207.57ZM1044.61 212.468L1045.83 211.599C1046.34 212.316 1046.89 213.004 1047.48 213.659L1046.36 214.659C1045.74 213.962 1045.15 213.231 1044.61 212.468ZM1048.34 216.641L1049.34 215.523C1050 216.109 1050.68 216.658 1051.4 217.168L1050.53 218.391C1049.77 217.848 1049.04 217.264 1048.34 216.641ZM1052.91 219.885L1053.63 218.573C1054.4 218.997 1055.19 219.379 1056 219.717L1055.43 221.103C1054.56 220.743 1053.72 220.336 1052.91 219.885ZM1058.08 222.029L1058.49 220.587C1059.33 220.828 1060.19 221.024 1061.06 221.171L1060.81 222.65C1059.88 222.494 1058.97 222.285 1058.08 222.029ZM1063.6 222.961L1063.68 221.464C1064.12 221.488 1064.56 221.5 1065 221.5C1065.44 221.5 1065.88 221.488 1066.32 221.464L1066.4 222.961C1065.94 222.987 1065.47 223 1065 223C1064.53 223 1064.06 222.987 1063.6 222.961ZM1069.19 222.65L1068.94 221.171C1069.81 221.024 1070.67 220.828 1071.51 220.587L1071.92 222.029C1071.03 222.285 1070.12 222.494 1069.19 222.65ZM1074.57 221.103L1074 219.717C1074.81 219.379 1075.6 218.997 1076.37 218.573L1077.09 219.885C1076.28 220.336 1075.44 220.743 1074.57 221.103ZM1079.47 218.391L1078.6 217.168C1079.32 216.658 1080 216.109 1080.66 215.523L1081.66 216.641C1080.96 217.264 1080.23 217.848 1079.47 218.391ZM1083.64 214.659L1082.52 213.659C1083.11 213.004 1083.66 212.316 1084.17 211.599L1085.39 212.468C1084.85 213.231 1084.26 213.962 1083.64 214.659ZM1086.88 210.095L1085.57 209.368C1086 208.602 1086.38 207.81 1086.72 206.995L1088.1 207.57C1087.74 208.437 1087.34 209.28 1086.88 210.095ZM1089.03 204.924L1087.59 204.509C1087.83 203.671 1088.02 202.814 1088.17 201.94L1089.65 202.19C1089.49 203.119 1089.29 204.032 1089.03 204.924ZM1089.96 199.403C1089.99 198.938 1090 198.471 1090 198C1090 197.529 1089.99 197.062 1089.96 196.597L1088.46 196.68C1088.49 197.117 1088.5 197.557 1088.5 198C1088.5 198.443 1088.49 198.883 1088.46 199.32L1089.96 199.403ZM1089.65 193.81L1088.17 194.06C1088.02 193.186 1087.83 192.329 1087.59 191.491L1089.03 191.076C1089.29 191.968 1089.49 192.881 1089.65 193.81ZM1088.1 188.43L1086.72 189.005C1086.38 188.19 1086 187.398 1085.57 186.632L1086.88 185.905C1087.34 186.72 1087.74 187.563 1088.1 188.43ZM1085.39 183.532L1084.17 184.401C1083.66 183.684 1083.11 182.996 1082.52 182.341L1083.64 181.341C1084.26 182.038 1084.85 182.769 1085.39 183.532ZM1081.66 179.359C1080.96 178.736 1080.23 178.152 1079.47 177.609L1078.6 178.832C1079.32 179.342 1080 179.891 1080.66 180.477L1081.66 179.359ZM1077.09 176.115L1076.37 177.427C1075.6 177.003 1074.81 176.621 1074 176.283L1074.57 174.897C1075.44 175.257 1076.28 175.664 1077.09 176.115ZM1071.92 173.971L1071.51 175.413C1070.67 175.172 1069.81 174.976 1068.94 174.829L1069.19 173.35C1070.12 173.506 1071.03 173.715 1071.92 173.971ZM1066.4 173.039L1066.32 174.536C1065.88 174.512 1065.44 174.5 1065 174.5C1064.56 174.5 1064.12 174.512 1063.68 174.536L1063.6 173.039C1064.06 173.013 1064.53 173 1065 173C1065.47 173 1065.94 173.013 1066.4 173.039ZM1060.81 173.35L1061.06 174.829C1060.19 174.976 1059.33 175.172 1058.49 175.413L1058.08 173.971C1058.97 173.715 1059.88 173.506 1060.81 173.35ZM1055.43 174.897L1056 176.283C1055.19 176.621 1054.4 177.003 1053.63 177.427L1052.91 176.115C1053.72 175.664 1054.56 175.257 1055.43 174.897ZM1050.53 177.609L1051.4 178.832C1050.68 179.342 1050 179.891 1049.34 180.477L1048.34 179.359C1049.04 178.736 1049.77 178.152 1050.53 177.609ZM1046.36 181.341L1047.48 182.341C1046.89 182.996 1046.34 183.684 1045.83 184.401L1044.61 183.532C1045.15 182.769 1045.74 182.038 1046.36 181.341ZM1043.12 185.905L1044.43 186.632C1044 187.398 1043.62 188.19 1043.28 189.005L1041.9 188.43C1042.26 187.563 1042.66 186.72 1043.12 185.905ZM1040.97 191.076L1042.41 191.491C1042.17 192.329 1041.98 193.186 1041.83 194.06L1040.35 193.81C1040.51 192.881 1040.71 191.968 1040.97 191.076Z"
        fill="var(--brand-color-red-5)"
        initial={{ opacity: 0, x: 342 }}
        animate={
          svgInView && {
            opacity: 1,
            x: 0,
            transition: { duration: 1, ease: 'easeOut' },
          }
        }
      />
      <motion.path
        d="M1024.75 198C1024.75 184.607 1035.61 173.75 1049 173.75C1062.39 173.75 1073.25 184.607 1073.25 198C1073.25 211.393 1062.39 222.25 1049 222.25C1035.61 222.25 1024.75 211.393 1024.75 198Z"
        stroke="var(--brand-color-red-5)"
        strokeWidth="1.5"
        initial={{ opacity: 0, x: 358 }}
        animate={
          svgInView && {
            opacity: 1,
            x: 0,
            transition: { duration: 1, ease: 'easeOut' },
          }
        }
      />
      <motion.ellipse
        cx="1033"
        cy="198"
        rx="25"
        ry="25"
        fill="var(--brand-color-red-5)"
        initial={{ opacity: 0, x: 374 }}
        animate={
          svgInView && {
            opacity: 1,
            x: 0,
            transition: { duration: 1, ease: 'easeOut' },
          }
        }
      />
      <g mask="url(#mask0)">
        <path
          d="M963.983 120H962.569L953 129.569V130.983L963.983 120Z"
          fill="#1BB694"
        />
        <path
          d="M953 138.983V137.569L970.569 120H971.983L953 138.983Z"
          fill="#1BB694"
        />
        <path
          d="M953 146.983V145.569L978.569 120H979.983L953 146.983Z"
          fill="#1BB694"
        />
        <path
          d="M953 154.983V153.569L986.569 120H987.983L953 154.983Z"
          fill="#1BB694"
        />
        <path
          d="M953 162.983V161.569L993 121.569V122.983L953 162.983Z"
          fill="#1BB694"
        />
        <path
          d="M953 170.983V169.569L993 129.569V130.983L953 170.983Z"
          fill="#1BB694"
        />
        <path
          d="M953 178.983V177.569L993 137.569V138.983L953 178.983Z"
          fill="#1BB694"
        />
        <path
          d="M953 186.983V185.569L993 145.569V146.983L953 186.983Z"
          fill="#1BB694"
        />
        <path
          d="M953 194.983V193.569L993 153.569V154.983L953 194.983Z"
          fill="#1BB694"
        />
        <path
          d="M953 202.983V201.569L993 161.569V162.983L953 202.983Z"
          fill="#1BB694"
        />
        <path
          d="M953 210.983V209.569L993 169.569V170.983L953 210.983Z"
          fill="#1BB694"
        />
        <path
          d="M953 218.983V217.569L993 177.569V178.983L953 218.983Z"
          fill="#1BB694"
        />
        <path
          d="M953 226.983V225.569L993 185.569V186.983L953 226.983Z"
          fill="#1BB694"
        />
        <path
          d="M953 234.983V233.569L993 193.569V194.983L953 234.983Z"
          fill="#1BB694"
        />
        <path
          d="M953 243.983V242.568L993 202.568V203.983L953 243.983Z"
          fill="#1BB694"
        />
        <path
          d="M953 251.983V250.569L993 210.569V211.983L953 251.983Z"
          fill="#1BB694"
        />
        <path
          d="M953 259.983V258.569L993 218.569V219.983L953 259.983Z"
          fill="#1BB694"
        />
        <path
          d="M953 267.983V266.569L993 226.569V227.983L953 267.983Z"
          fill="#1BB694"
        />
        <path
          d="M953 275.983V274.569L993 234.569V235.983L953 275.983Z"
          fill="#1BB694"
        />
        <path
          d="M957.983 279H956.569L993 242.569V243.983L957.983 279Z"
          fill="#1BB694"
        />
        <path
          d="M965.983 279H964.569L993 250.569V251.983L965.983 279Z"
          fill="#1BB694"
        />
        <path
          d="M973.983 279H972.569L993 258.569V259.983L973.983 279Z"
          fill="#1BB694"
        />
        <path
          d="M981.983 279H980.569L993 266.569V267.983L981.983 279Z"
          fill="#1BB694"
        />
        <path
          d="M989.983 279H988.569L993 274.569V275.983L989.983 279Z"
          fill="#1BB694"
        />
      </g>
      <g mask="url(#mask1)">
        <path
          d="M123.983 0H122.569L113 9.56861V10.9828L123.983 0Z"
          fill="#1BB694"
        />
        <path
          d="M113 18.9828V17.5686L130.569 0H131.983L113 18.9828Z"
          fill="#1BB694"
        />
        <path
          d="M113 26.9828V25.5686L138.569 0H139.983L113 26.9828Z"
          fill="#1BB694"
        />
        <path
          d="M113 34.9828V33.5686L146.569 0H147.983L113 34.9828Z"
          fill="#1BB694"
        />
        <path
          d="M113 42.9828V41.5686L153 1.56861V2.98282L113 42.9828Z"
          fill="#1BB694"
        />
        <path
          d="M113 50.9828V49.5686L153 9.56861V10.9828L113 50.9828Z"
          fill="#1BB694"
        />
        <path
          d="M113 58.9828V57.5686L153 17.5686V18.9828L113 58.9828Z"
          fill="#1BB694"
        />
        <path
          d="M113 66.9828V65.5686L153 25.5686V26.9828L113 66.9828Z"
          fill="#1BB694"
        />
        <path
          d="M113 74.9828V73.5686L153 33.5686V34.9828L113 74.9828Z"
          fill="#1BB694"
        />
        <path
          d="M113 82.9828V81.5686L153 41.5686V42.9828L113 82.9828Z"
          fill="#1BB694"
        />
        <path
          d="M113 90.9828V89.5686L153 49.5686V50.9828L113 90.9828Z"
          fill="#1BB694"
        />
        <path
          d="M113 98.9828V97.5686L153 57.5686V58.9828L113 98.9828Z"
          fill="#1BB694"
        />
        <path
          d="M113 106.983V105.569L153 65.5686V66.9828L113 106.983Z"
          fill="#1BB694"
        />
        <path
          d="M113 114.983V113.569L153 73.5686V74.9828L113 114.983Z"
          fill="#1BB694"
        />
        <path
          d="M113 123.983V122.568L153 82.5684V83.9826L113 123.983Z"
          fill="#1BB694"
        />
        <path
          d="M113 131.983V130.569L153 90.5686V91.9828L113 131.983Z"
          fill="#1BB694"
        />
        <path
          d="M113 139.983V138.569L153 98.5686V99.9828L113 139.983Z"
          fill="#1BB694"
        />
        <path
          d="M113 147.983V146.569L153 106.569V107.983L113 147.983Z"
          fill="#1BB694"
        />
        <path
          d="M113 155.983V154.569L153 114.569V115.983L113 155.983Z"
          fill="#1BB694"
        />
        <path
          d="M117.983 159H116.569L153 122.569V123.983L117.983 159Z"
          fill="#1BB694"
        />
        <path
          d="M125.983 159H124.569L153 130.569V131.983L125.983 159Z"
          fill="#1BB694"
        />
        <path
          d="M133.983 159H132.569L153 138.569V139.983L133.983 159Z"
          fill="#1BB694"
        />
        <path
          d="M141.983 159H140.569L153 146.569V147.983L141.983 159Z"
          fill="#1BB694"
        />
        <path
          d="M149.983 159H148.569L153 154.569V155.983L149.983 159Z"
          fill="#1BB694"
        />
      </g>
      <defs>
        <mask id="mask0">
          <motion.rect
            x="953"
            y="120"
            height="159"
            fill="white"
            initial={{ width: 0 }}
            animate={
              svgInView && {
                width: 40,
                transition: { duration: 1, ease: 'easeOut' },
              }
            }
          />
        </mask>
        <mask id="mask1">
          <motion.rect
            y="0"
            height="159"
            fill="white"
            initial={{ width: 0, x: 153 }}
            animate={
              svgInView && {
                width: 40,
                x: 113,
                transition: { duration: 1, ease: 'easeOut' },
              }
            }
          />
        </mask>
      </defs>
    </svg>
  );
};
